import React from "react";

import Select from "./index";

export default function InvoiceType(props) {
  const items = ["ACCREC", "ACCPAY"];

  return <Select name="type" items={items} {...props} />;
}
